import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LightWeightOperator } from '../util/types-constants';

@Component({
  selector: 'coin-v2-lightweight-operator-icon',
  templateUrl: './operator-icon.component.html',
  styleUrls: ['./operator-icon.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2LightweightOperatorIconComponent {
  operator = input.required<LightWeightOperator>();
}
